import InfoIcon from 'components/ReusableComponents/Icons/Info'
import { useSelector } from 'react-redux'

import styles from './TaxInfoDialog.module.scss'

const EinHint = ({ province, isCanadian }) => {
  const cultureCode = useSelector(s => s.hotelDetails.cultureCode)

  if (isCanadian || cultureCode === 'en-CA') {
    return (
      <ul className={styles.warnings}>
        {province === 'BC' && (
          <li>
            <InfoIcon />7 digits followed by BC, with padded zeros e.g BC0001234
          </li>
        )}
        {province === 'ON' && (
          <li>
            <InfoIcon />
            Remove leading zeros. E.g 223345 instead of 00223345
          </li>
        )}
        <li>
          <InfoIcon />
          Enter CN of your property, not your management group.
        </li>
        <li>
          <InfoIcon />
          Do not enter business number or tax number.
        </li>
      </ul>
    )
  } else {
    return (
      <ul className={styles.warnings}>
        <li>
          <InfoIcon />
          Enter EIN of your property, not your management group.
        </li>
        <li>
          <InfoIcon />
          The number you entered will be verified by IRS
        </li>
      </ul>
    )
  }
}

export default EinHint
